import { useEffect } from "react";
import { Link } from "wouter";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { CheckCircle, ArrowRight, Building, Shield } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function ThankYouBusiness() {
  useEffect(() => {
    // Track business form conversion
    if (typeof window !== 'undefined' && window.gtag) {
      window.gtag('event', 'conversion', {
        'send_to': 'BUSINESS_FORM_CONVERSION'
      });
    }
  }, []);

  return (
    <div className="min-h-screen bg-musicBlack">
      <Header />
      
      <section className="pt-24 pb-16 section-dark">
        <div className="editorial-container text-center">
          <div className="max-w-2xl mx-auto">
            {/* Success Icon */}
            <div className="mb-8">
              <CheckCircle className="w-20 h-20 text-musicRed mx-auto mb-4" />
              <h1 className="text-4xl md:text-5xl font-serif text-musicWhite mb-4">
                Thank You for Your Interest!
              </h1>
              <p className="text-xl text-musicGrey">
                Your business licensing inquiry has been received
              </p>
            </div>

            {/* Success Message */}
            <div className="bg-musicGrey/10 rounded-lg p-8 mb-8">
              <h2 className="text-2xl font-bold text-musicWhite mb-4">
                Your Business Registration is Complete
              </h2>
              <p className="text-musicGrey mb-6 leading-relaxed">
                Our licensing team will review your business requirements and contact you 
                within 1-2 business days with a customized licensing solution and pricing 
                that fits your needs.
              </p>
              
              <div className="grid md:grid-cols-2 gap-6 text-left">
                <div className="flex items-start gap-3">
                  <Shield className="w-5 h-5 text-musicRed mt-1 flex-shrink-0" />
                  <div>
                    <h3 className="font-semibold text-musicWhite mb-1">Legal Compliance</h3>
                    <p className="text-sm text-musicGrey">Ensure your business music usage is fully licensed</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <Building className="w-5 h-5 text-musicRed mt-1 flex-shrink-0" />
                  <div>
                    <h3 className="font-semibold text-musicWhite mb-1">Custom Solutions</h3>
                    <p className="text-sm text-musicGrey">Tailored licensing for your business type</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Next Steps */}
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link to="/">
                <Button className="cta-button">
                  <ArrowRight className="w-4 h-4 mr-2" />
                  Return Home
                </Button>
              </Link>
              <Link to="/businesses">
                <Button variant="outline" className="border-musicRed text-musicRed hover:bg-musicRed hover:text-white">
                  Learn More About Business Licensing
                </Button>
              </Link>
            </div>

            {/* Contact Info */}
            <div className="mt-12 pt-8 border-t border-musicGrey/20">
              <p className="text-musicGrey mb-2">
                Need immediate assistance with licensing?
              </p>
              <a 
                href="mailto:contact@wearemusicnation.ae"
                className="text-musicRed hover:text-musicRedDark font-medium"
              >
                contact@wearemusicnation.ae
              </a>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}